import { graphql } from "@cappelendamm/crystallize-types/orders/gql";
const GetOrdersByCustomerId = graphql(`
  query GetOrdersByCustomerId($customerId: String!) {
    orders {
      getAll(customerIdentifier: $customerId) {
        edges {
          node {
            id
            reference
            createdAt
            cart {
              ...Cart
            }
            total {
              net
              gross
            }
            meta {
              key
              value
            }
          }
        }
      }
    }
  }

  fragment Cart on OrderItem {
    price {
      net
      gross
    }
    imageUrl
    sku
    name
    quantity
    subTotal {
      net
      gross
    }
    meta {
      key
      value
    }
  }
`);
export default GetOrdersByCustomerId;
